var React = require('react');

function Subscribe (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"9.02 8.76 1.58 3.77 1.58 3.75 16.46 3.75 9.02 8.76","key":0}),React.createElement("polygon",{"points":"9.02 11.29 16.46 6.29 16.46 13.74 1.58 13.74 1.58 6.3 9.02 11.29","key":1})]);
}

Subscribe.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Subscribe;

Subscribe.default = Subscribe;
